//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Table from '../../../../../components/Table/Table.vue'
import ReportCheckListCableSegment from './ReportCheckListCableSegment.vue'
import { EventBus } from '../../../../../EventBus/EventBus.js'

export default {
  components: {
    Table,
    ReportCheckListCableSegment
  },
  props: {
    segments: {
      type: Array,
      default () {
        return []
      }
    },
    reports: {
      type: Array,
      default () {
        return []
      }
    },
    materialsSourceReport: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default () {
        return ''
      }
    },
    otherDeparture: {
      type: Boolean,
      default: false
    },
    pointTypes: {
      type: Array,
      default: function () {
        return []
      }
    },
    layingTypes: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      segment: {
        start: null,
        startId: null,
        end: null,
        endId: null,
        layingType: null,
        mountingId: null,
        demountingId: null
      },
      operation: {
        index: -1,
        type: null
      },
      openedSegment: false,
      columns: [
        {
          name: 'start',
          label: 'От',
          align: 'left',
          field: (row) => row.start ? (row.start + (row.startId ? ' ' + row.startId : '')) : '',
          style: 'width: 140px;'

        },
        {
          name: 'end',
          label: 'До',
          align: 'left',
          field: (row) => row.end ? (row.end + (row.endId ? ' ' + row.endId : '')) : '',
          style: 'width: 140px;'

        },
        {
          name: 'layingType',
          label: 'Способ прокладки',
          align: 'left',
          field: 'layingType',
          style: 'width: 180px;'
        },
        {
          name: 'toolName',
          label: 'Название',
          align: 'left',
          field: (row) => this.getMaterialValueByProperty(row, 'toolName'),
          style: 'min-width: 150px;'
        },
        {
          name: 'amount',
          label: 'Кол-во',
          align: 'left',
          field: (row) => this.getMaterialValueByProperty(row, 'amount'),
          style: 'width: 40px;'

        },
        {
          name: 'unit',
          label: 'Ед. изм.',
          align: 'left',
          field: (row) => this.getMaterialValueByProperty(row, 'unit'),
          style: 'width: 40px;'
        }
      ]
    }
  },
  computed: {
    recId: function () {
      return this.type + 'Id'
    },
    materialsName: function () {
      return this.type + 's' + (this.otherDeparture && 'FromOtherDepartures' || '')
    },
    readonly: function () {
      return !!this.otherDeparture
    }
  },
  methods: {
    formatQualifications: function (qualifications) {
      if (qualifications) {
        return qualifications.join(', ')
      }
    },
    onAddSegment: function () {
      this.operation.type = 'add'
      this.operation.index = -1

      this.openedSegment = true
    },
    onAddSegmentBefore: function () {
      this.operation.type = 'addBefore'
      this.operation.index = -1

      this.segment.end = this.segments[0].start
      this.segment.endId = this.segments[0].startId

      this.openedSegment = true
    },
    onAddSegmentAfter: function () {
      this.operation.type = 'addAfter'
      this.operation.index = -1

      this.segment.start = this.segments[this.segments.length - 1].end
      this.segment.startId = this.segments[this.segments.length - 1].endId

      this.openedSegment = true
    },
    onDeleteSegments: function () {
      this.$emit('delete')
    },
    onEditSegment: function (row) {
      this.operation.type = 'edit'
      this.operation.index = this.segments.findIndex(segment => segment === row)

      this.segment = JSON.parse(JSON.stringify(row))

      this.openedSegment = true
    },
    onDivideSegment: function (row) {
      this.operation.type = 'divide'
      this.operation.index = this.segments.findIndex(segment => segment === row)

      this.openedSegment = true
    },
    onDeleteSegment: function (row) {
      const index = this.segments.findIndex(segment => segment === row)
      if (index !== -1) {
        this.segments.splice(index, 1)
      }
      if (row[this.recId]) {
        EventBus.$emit(this.type + '-segment', { segment: row, operation: { type: 'delete' }, reportKey: this.materialsSourceReport.key })
      }
    },
    onSaveSegment: function (row) {
      const segment = JSON.parse(JSON.stringify(row))

      if (this.operation.type === 'edit' && this.operation.index !== -1) {
        this.segments.splice(this.operation.index, 1, segment)
      } else if (this.operation.type === 'addBefore') {
        this.segments.unshift(segment)
      } else if (this.operation.type === 'divide') {
        segment.end = this.segments[this.operation.index].end
        segment.endId = this.segments[this.operation.index].endId
        this.segments[this.operation.index].end = segment.start
        this.segments[this.operation.index].endId = segment.startId

        this.segments.splice(this.operation.index + 1, 0, segment)
      } else {
        this.segments.push(segment)
      }

      EventBus.$emit(this.type + '-segment', { segment: segment, operation: this.operation, reportKey: this.materialsSourceReport.key })

      this.onCloseSegment()
    },
    onCloseSegment: function () {
      this.segment.start = null
      this.segment.startId = null
      this.segment.end = null
      this.segment.endId = null
      this.segment.layingType = null
      this.segment[this.recId] = null

      this.operation.index = -1
      this.operation.type = null

      this.openedSegment = false
    },
    getMaterialValueByProperty: function (row, prop) {
      let value = ''
      if (this.materialsSourceReport) {
        const materials = this.materialsSourceReport[this.materialsName]
        if (materials) {
          const material = materials.find(material => material.recId === row[this.recId])
          if (material) {
            value = material[prop]
          } else {
            this.reports.find(report => {
              const reportMaterials = report[this.materialsName]
              if (reportMaterials) {
                const reportMaterial = reportMaterials.find(material => material.recId === row[this.recId])
                if (reportMaterial) {
                  value = reportMaterial[prop]
                }
              }
            })
          }
        }
      }
      return value
    }
  }
}

